import React from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { saveAs } from 'file-saver';
import { Button } from '@mui/material';
import SimCardDownloadRoundedIcon from '@mui/icons-material/SimCardDownloadRounded';
const PaySlipPdf = ({
  paySlip,
  company_logo,
  workingData,
  payslipMonthRange,
}) => {
  const generatePDF = async () => {
    console.log('Generating PDF for payslip:', paySlip);
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([600, 850]);
    const { width, height } = page.getSize();
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    // Add Company Logo on the left side
    const logoImageBytes = await fetch(paySlip.company_logo).then((res) =>
      res.arrayBuffer()
    );
    const logoImage = await pdfDoc.embedJpg(logoImageBytes);
    const logoDims = logoImage.scale(0.17); // Scale the logo to fit nicely
    page.drawImage(logoImage, {
      x: 360,
      y: height - logoDims.height - 85,
      width: logoDims.width,
      height: logoDims.height,
    });
    // Add Company Name in the center
    const companyName = paySlip.company_name || 'KG BUILD TECH';
    const textWidth = fontBold.widthOfTextAtSize(companyName, 18);

    // page.drawText(companyName, {
    //   x: (width - textWidth) / 2,
    //   y: height - 100,
    //   size: 15,
    //   font: fontBold,
    //   color: rgb(0, 0.4, 0.8),
    // });

    page.drawText(paySlip.address, {
      x: 350,
      y: height - 163,
      size: 9,
      font,
      color: rgb(0, 0, 0),
    });

    // Add Date on the right side
    page.drawText(`Payslip break down: ${payslipMonthRange}`, {
      x: 350,
      y: height - 179,
      size: 9,
      font: fontBold,
      color: rgb(0, 0, 0),
    });
    page.drawLine({
      start: { x: 30, y: height - 50 },
      end: { x: width - 30, y: height - 50 },
      thickness: 1,
      color: rgb(0, 0, 0),
    });
    // Employee details below the header
    const detailsY = height - 100;
    page.drawText(`Employee Name`, {
      x: 33,
      y: detailsY,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.employee_name, {
      x: 160,
      y: detailsY,
      size: 10,
      font,
    });

    page.drawText(`Employee ID`, {
      x: 33,
      y: detailsY - 20,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.employee_no, {
      x: 160,
      y: detailsY - 20,
      size: 10,
      font,
    });

    page.drawText(`Designation`, {
      x: 33,
      y: detailsY - 40,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.position, {
      x: 160,
      y: detailsY - 40,
      size: 10,
      font,
    });

    page.drawText(`Company Name`, {
      x: 33,
      y: detailsY - 60,
      size: 10,
      font: fontBold,
    });
    page.drawText(companyName, {
      x: 160,
      y: detailsY - 60,
      size: 10,
      font,
    });

    page.drawText(`Department`, {
      x: 33,
      y: detailsY - 80,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.department_name, {
      x: 160,
      y: detailsY - 80,
      size: 10,
      font,
    });

    page.drawText(`Bank Name`, {
      x: 33,
      y: detailsY - 100,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.bank_name, {
      x: 160,
      y: detailsY - 100,
      size: 10,
      font,
    });

    page.drawText(`A/c. Number`, {
      x: 33,
      y: detailsY - 120,
      size: 10,
      font: fontBold,
    });
    page.drawText(paySlip.account_number, {
      x: 160,
      y: detailsY - 120,
      size: 10,
      font,
    });

    // Add Table

    // Draw rows for emoluments and deductions
    const totalDays = workingData?.totalDays || 30;
    const leaveDays = paySlip.no_of_days_leave_taken || 0;
    const casualLeave = paySlip.casual_leave || 0;
    const unpaidLeave = Math.max(0, leaveDays - casualLeave);
    const paidDays = Math.max(0, totalDays - unpaidLeave);

    const earnedBasic = Math.round(
      ((paySlip.basic_pay || 0) * paidDays) / totalDays
    );
    const earnedHRA = Math.round(
      ((paySlip.house_allowance || 0) * paidDays) / totalDays
    );
    const earnedMedical = Math.round(
      ((paySlip.medical_allowance || 0) * paidDays) / totalDays
    );
    const earnedConveyance = Math.round(
      ((paySlip.vehicle_allowance || 0) * paidDays) / totalDays
    );
    const earnedOther = Math.round(
      ((paySlip.other_allowance || 0) * paidDays) / totalDays
    );
    const earnedPetrol = Math.round(
      ((paySlip.petrol_conveyance || 0) * paidDays) / totalDays
    );
    const otSalary = Math.round(
      (paySlip.ot_hrs || 0) * ((paySlip.actual_pay || 0) / totalDays / 8)
    );

    const emoluments = [
      {
        label: "Actual Salary",
        actual: paySlip.actual_pay,
        value: Math.round(((paySlip.actual_pay || 0) * paidDays) / totalDays),
      },
      { label: "Basic Salary", actual: paySlip.basic_pay, value: earnedBasic },
      { label: "HRA", actual: paySlip.house_allowance, value: earnedHRA },
      {
        label: "Medical Allowance",
        actual: paySlip.medical_allowance,
        value: earnedMedical,
      },
      {
        label: "Conveyance Allowance",
        actual: paySlip.vehicle_allowance,
        value: earnedConveyance,
      },
      {
        label: "Other Allowance",
        actual: paySlip.other_allowance,
        value: earnedOther,
      },
      { label: "OT Salary", actual: 0, value: otSalary },
      {
        label: "Petrol Conveyance",
        actual: paySlip.petrol_conveyance ?? 0,
        value: earnedPetrol,
      },
      { label: " ", actual: " ", value: " " },
      {
        label: "Gross Pay",
        actual: paySlip.actual_pay,
        value: paySlip.gross_pay,
        bold: true,
      },
    ];
    const deductions = [
      { label: "Total Days", value: workingData?.totalDays },
      { label: "Full Days", value: paySlip.full_days },
      { label: "Leave Days", value: paySlip.no_of_days_leave_taken },
      { label: "Casual Leave", value: paySlip.casual_leave ?? 0 },
      { label: "OT Hours", value: paySlip.ot_hrs },
      { label: "Salary Advance (Same Month)", value: paySlip.salary_advance },
      {
        label: "Personal Advance (Monthly Wise)",
        value: paySlip.personal_advance,
      },
      {
        label: "Employee Provident Fund (EPF)",
        value: paySlip.epf_fund,
      },
      {
        label: "Professional Tax (PT) (200 TO 2000)",
        value: paySlip.professional_tax ?? 0,
      },
      {
        label: "Tax Deducted at Source (TDS)",
        value: paySlip.income_tax,
      },
      { label: "ESI", value: paySlip.rd_esi ?? 0 },
      {
        label: "Total Deductions",
        value: paySlip.total_deductions,
        bold: true,
      },
      { label: "Net Pay", value: paySlip.net_pay, bold: true },
    ];

    // Define table dimensions (5 columns)
    const tableX = 25; // Starting X position
    const tableY = height - 250; // Starting Y position
    const cellHeight = 20;
    const col1Width = 180; // Column 1 width
    const col2Width = 55; // Column 2 width
    const col3Width = 55; // Column 3 width
    const col4Width = 190; // Column 4 width
    const col5Width = 65; // Column 5 width

    const col1X = tableX;
    const col2X = col1X + col1Width;
    const col3X = col2X + col2Width;
    const col4X = col3X + col3Width;
    const col5X = col4X + col4Width;

    // Draw table headers
    page.drawRectangle({
      x: tableX,
      y: tableY - cellHeight,
      width: col5X + col5Width - tableX,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
      color: rgb(217 / 255, 217 / 255, 217 / 255),
    });

    page.drawText("Emoluments", {
      x: col1X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 9,
    });

    page.drawText("Actual Rs.", {
      x: col2X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 9,
    });

    page.drawText("Earned Rs.", {
      x: col3X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 9,
    });

    page.drawText("Deductions", {
      x: col4X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 9,
    });

    page.drawText("Amount Rs.", {
      x: col5X + 5,
      y: tableY - 15,
      font: fontBold,
      size: 9,
    });

    const maxLength = Math.max(emoluments.length, deductions.length);

    for (let i = 0; i < maxLength; i++) {
      const yPos = tableY - (i + 2) * cellHeight;

      const emolument = emoluments[i];
      const deduction = deductions[i];

      // Determine background color for Emoluments side
      let emolumentsColor = undefined;
      if (i === 0) {
        emolumentsColor = rgb(217 / 255, 217 / 255, 217 / 255); // light grey for Actual Salary
      } else if (emolument && emolument.label === "Gross Pay") {
        emolumentsColor = rgb(1.0, 0.85, 0.4); // yellow/gold
      }

      // Determine background color for Deductions side
      let deductionsColor = undefined;
      if (deduction && deduction.label === "Total Deductions") {
        deductionsColor = rgb(0.99, 0.89, 0.84); // light pink
      } else if (deduction && deduction.label === "Net Pay") {
        deductionsColor = rgb(0.89, 0.94, 0.85); // light green
      }

      // --- Emoluments side (3 columns: label, actual, earned) ---
      page.drawRectangle({
        x: col1X,
        y: yPos,
        width: col1Width,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: emolumentsColor,
      });

      page.drawRectangle({
        x: col2X,
        y: yPos,
        width: col2Width,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: emolumentsColor,
      });

      page.drawRectangle({
        x: col3X,
        y: yPos,
        width: col3Width,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: emolumentsColor,
      });

      if (emolument) {
        page.drawText(emolument.label || "", {
          x: col1X + 5,
          y: yPos + 5,
          font: emolument.bold ? fontBold : font,
          size: 9,
        });

        page.drawText(
          (emolument.actual ?? "").toLocaleString?.() || "",
          {
            x: col2X + 5,
            y: yPos + 5,
            font: emolument.bold ? fontBold : font,
            size: 9,
            textAlign: "right",
          }
        );

        page.drawText(
          (emolument.value ?? "").toLocaleString?.() || "",
          {
            x: col3X + 5,
            y: yPos + 5,
            font: emolument.bold ? fontBold : font,
            size: 9,
            textAlign: "right",
          }
        );
      }

      // --- Deductions side (2 columns: label, value) ---
      page.drawRectangle({
        x: col4X,
        y: yPos,
        width: col4Width,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: deductionsColor,
      });

      page.drawRectangle({
        x: col5X,
        y: yPos,
        width: col5Width,
        height: cellHeight,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
        color: deductionsColor,
      });

      if (deduction) {
        page.drawText(deduction.label || "", {
          x: col4X + 5,
          y: yPos + 5,
          font: deduction.bold ? fontBold : font,
          size: 9,
        });

        page.drawText(
          (deduction.value ?? "").toLocaleString?.() || "",
          {
            x: col5X + 5,
            y: yPos + 5,
            font: deduction.bold ? fontBold : font,
            size: 9,
            textAlign: "right",
          }
        );
      }
    }

    // system generated payslip
    const systemMessageY = tableY - (maxLength + 2) * cellHeight;
    const message = "THIS IS SYSTEM GENERATED PAYSLIP";
    const deductionCellWidth = col5X + col5Width - col4X;
    const lightGray = rgb(0.6, 0.6, 0.6);

    // Draw empty emoluments side to keep alignment
    page.drawRectangle({
      x: col1X,
      y: systemMessageY,
      width: col1Width,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });
    page.drawRectangle({
      x: col2X,
      y: systemMessageY,
      width: col2Width,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });
    page.drawRectangle({
      x: col3X,
      y: systemMessageY,
      width: col3Width,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });

    // Draw full-width deductions area (col4 + col5)
    page.drawRectangle({
      x: col4X,
      y: systemMessageY,
      width: deductionCellWidth,
      height: cellHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });

    // Center text in deduction area
    const messageTextWidth = font.widthOfTextAtSize(message, 10);
    const messageCenterX = col4X + (deductionCellWidth - messageTextWidth) / 2;

    page.drawText(message, {
      x: messageCenterX,
      y: systemMessageY + 5,
      font: fontBold,
      size: 10,
      color: lightGray,
    });

    // Signature section setup
    const signatureHeight = cellHeight * 5;
    const signatureY = systemMessageY - signatureHeight;

    const fullSignatureWidth = col5X + col5Width - col1X;
    const emolumentsWidth = col4X - col1X;
    const deductionsWidth = col5X + col5Width - col4X;

    // 1. Draw full connected signature area
    page.drawRectangle({
      x: col1X,
      y: signatureY,
      width: fullSignatureWidth,
      height: signatureHeight,
      borderColor: rgb(0, 0, 0),
      borderWidth: 1,
    });

    // 2. Draw vertical dividing line to split left/right sides
    page.drawLine({
      start: { x: col4X, y: signatureY },
      end: { x: col4X, y: signatureY + signatureHeight },
      thickness: 1,
      color: rgb(0, 0, 0),
    });

    // 3. Add centered signature text in Emoluments side
    const leftText = 'Employee Signature';
    const leftTextWidth = font.widthOfTextAtSize(leftText, 10);
    const leftTextX = col1X + (emolumentsWidth - leftTextWidth) / 2;

    page.drawText(leftText, {
      x: leftTextX,
      y: signatureY + 5,
      font,
      size: 10,
    });

    // 4. Add centered signature text in Deductions side
    const rightText = 'Employer Signature'; // Fixed: typically right side is Employer/Authorized Signature
    const rightTextWidth = font.widthOfTextAtSize(rightText, 10);
    const rightTextX = col4X + (deductionsWidth - rightTextWidth) / 2;

    page.drawText(rightText, {
      x: rightTextX,
      y: signatureY + 5,
      font,
      size: 10,
    });

    const drawFooter = async (page, pageNumber) => {
      const { width } = page.getSize();
      const margin = 30;
      const fontSize = 10;
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

      page.drawLine({
        start: { x: margin, y: margin },
        end: { x: width - margin, y: margin },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
      page.drawText(`KG Build Tech`, {
        x: width / 2 - 10,
        y: margin - 20,
        size: fontSize,
        font,
        color: rgb(0, 0.4, 0.8),
      });
      page.drawText(` • ${pageNumber} • `, {
        x: width - margin - 50,
        y: margin - 20,
        size: fontSize,
        font,
        color: rgb(0, 0.4, 0.8),
      });
    };

    drawFooter(page, 1);

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    saveAs(
      blob,
      `payslip_${paySlip.employee_name}_${paySlip.payslip_date}.pdf`
    );
  };
  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        size='large'
        startIcon={<SimCardDownloadRoundedIcon />}
        onClick={generatePDF}
        sx={{
          backgroundColor: '#2196f3',
          fontWeight: 'bold',
          transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            backgroundColor: '#FFF',
            color: '#2196f3',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        Generate PDF
      </Button>
    </div>
  );
};
export default PaySlipPdf;
